<template>
  <v-card v-show="myob && myob.missingSuppliers">
    <v-card-title primary-title>
      <app-title>Missing Suppliers</app-title>
    </v-card-title>
    <ag-grid-vue
      style="width: 100%;"
      class="ag-theme-balham"
      :rowData="myob.missingSuppliers"
      :columnDefs="columnDefs"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      enableCellTextSelection
      domLayout="autoHeight"
    ></ag-grid-vue>
  </v-card>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "MyobReview",
  components: {
    AgGridVue
  },
  data() {
    return {
      message: {},
      gridOptions: {},
      defaultColDef: { resizeable: true, sortable: true },
      columnDefs: []
    };
  },
  props: {
    myob: {
      type: Object,
      required: true
    }
  },
  beforeMount() {
    this.columnDefs = [
      { headerName: "dealerID", field: "dealerID" },
      { headerName: "registeredCompanyName", field: "registeredCompanyName" },
      { headerName: "Director Name", field: "directorsName" },
      { headerName: "Account Name", field: "accountName" },
      { field: "bsbNo" },
      { field: "accountNo" }
    ];
  }
};
</script>
